import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter , MDBJumbotron,MDBCardBody, MDBCardText,  MDBCardTitle, MDBCardImage ,Link} from 'mdbreact';

import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';

import Axios from 'axios'
import { URL } from '../api';
import logo from './img/logokpru.png'
import background from "./img/5543.jpg";
//import "../index.css";
import Swal from 'sweetalert2'
import CookieConsent from "react-cookie-consent";


export default class Home extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.register = this.register.bind(this);
            this.login = this.login.bind(this);

          }
        //  window.location.href = '/Curriculum'
          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();

            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
         datafrm.append("txtemail", this.state.value);
         datafrm.append("txtpass", this.state.Psaaword);

         
         const user = {
          "txtemail": this.state.value,
          "txtpass": this.state.Psaaword
        };

         fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
          method: 'POST',
          body: JSON.stringify(user),
          headers: {
        
          }
        })
          .then(res => res.json())
          .then((res) => {
              console.log(res);
              if (res[0].loginstatus === "1" ) {

           
                //  alert("เข้าสู่ระบบสำเร็จ")

                   localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
      
                   message.success("เข้าสู่ระบบสำเร็จ")
                   localStorage.setItem('loginstatus', res[0].loginstatus);
                   localStorage.setItem('type2', res[0].employee_id);
                   localStorage.setItem('admin_type', 2);
                 
              //   window.location.href = '/components/administrator/reportall'
             // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
            //  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfaculty'
            //  window.location.href = '/vaccinekpru/Stuall'
              }else{
                 // message.error("เข้าสู่ระบบไม่สำเร็จ")
                  
                 Swal.fire(
                  'ไม่สามารถเข้าถึงระบบได้',
                  'กรุณาลองอีกครั้ง',
                  'question'
                )
                //  window.location.href = '/'
              }
            
          })
          .catch(err => {
            console.log('request failed', err);
          })
         

          }

          register() {
           // window.location.href = '/Register'
            window.location.href = '/creditbank/Register2'
            // this.setState({Register
            //   collapse: !this.state.collapse,
            // });
          }

          login() {
          //  window.location.href = '/Login'
            window.location.href = '/creditbank/Login'
            // this.setState({
            //   collapse: !this.state.collapse,
            // });
          }
      
        //   handleSubmit(event) {
        //     // alert('A name was submitted: ' + this.state.value);
        //      event.preventDefault();
        //     const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        //  datafrm.append("Username", this.state.value);
        //  datafrm.append("Psaaword", this.state.Psaaword);

        //  Axios
        //  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
        //    .post("https://research.kpru.ac.th/culture/apiculture/selectadmin.php",datafrm)
        //    .then(res => {
        //      console.log("response: ", res)
        //      if (res.data.length !== 0) {
        //       // this.showitem = true;
        //        console.log(res)
        //        console.log(res.data.length)

        //        if (res.data[0].register_status === "1") {

        //         return this.setState({
        //           loading: true,
        //           // token_exp: +decodedEXP + "000"  //เก็บค่าหมดอายุของ token มาไว้ในตัวแปร
        //         }),
        //           //   localStorage.setItem('tokenExp', decodedEXP + "000"),
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           //   localStorage.setItem('profile', JSON.stringify(res.data[0]))
        //          // window.location.href = 'https://research.kpru.ac.th/culture/'
        //           window.location.href = '/adminfaculty'
    
        //       }
        //       else if (res.data[0].register_status === "2") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].Name),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //           // window.location.href = 'https://research.kpru.ac.th/culture/superadmin'
        //           window.location.href = '/Timetable'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }
        //       else if (res.data[0].register_status === "3") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('expert_id', res.data[0].id)
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //          // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/expert'
        //          // window.location.href = '/expert'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }  else if (res.data[0].register_status === "4") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('admin_faculty', res.data[0].register_faculty)
    
        //         // localStorage.setItem('picuser', data[0].picture);

        //         //  window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
        //         // window.location.href = '/adminfaculty'
        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }

        //      }else{
        //       this.setState({
        //         modal: true
               
        //     })
        //       // window.location.href = '/'
        //       // window.location.href = '/'
        //      }
        //      // do something about response
        //    })

        //   }


          // handleSubmit(event) {
          //   console.log(this.state.value)
          //   if (this.state.value === '1620600091565') {

           
          //     //  alert("เข้าสู่ระบบสำเร็จ")

          //       // localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
    
          //        message.success("เข้าสู่ระบบสำเร็จ")
          //        localStorage.setItem('nameuser', 'ชุลีพร')
          //        localStorage.setItem('admin_type', 4)
          //      //  localStorage.setItem('loginstatus', res[0].loginstatus);
          //     //   localStorage.setItem('type2', res[0].employee_id);
               
          //   //   window.location.href = '/components/administrator/reportall'
          //  // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
          //   window.location.href = '/tess/adminfaculty'
          //   }else{
          //      // message.error("เข้าสู่ระบบไม่สำเร็จ")
          //      Swal.fire(
          //       'ไม่สามารถเข้าถึงระบบได้',
          //       'กรุณาลองอีกครั้ง',
          //       'question'
          //     )
          //     //  window.location.href = '/'
          //   }


          // }



    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    render() {

      // const overlay = (
      //   <div
      //     id="sidenav-overlay"
      //     style={{ backgroundColor: "transparent" }}
      //     onClick={this.toggleCollapse("navbarCollapse")}
      //   />
      // );
      
        return (
          <div>
          {/* <div style={{ backgroundImage: `url(${background})` }}> */}
          {/* <MDBContainer style={{ backgroundImage: `url(${background})` }} fluid> */}
                 {/* <div className="bg"> */}
                 
           <MDBContainer fluid > 
           <img src={background} className="rounded mx-auto d-block w-100" alt="aligment" />       
            <MDBJumbotron  >
                 
              <MDBCardBody >
              {/* <MDBCardImage
              src={background}
              className="img-fluid"
            /> */}
                   <MDBRow >
                      <MDBCol md="6">
                            <MDBCardTitle className="h2" >
                              ระบบคลังหน่วยกิต มหาวิทยาลัยราชภัฏกำแพงเพชร
                              </MDBCardTitle>
                              <p className="blue-text my-4 font-weight-bold">
                              <bdi >KPRU</bdi>-CREDITBANK
                              </p>
                              <MDBBtn outline  href="https://e-student.kpru.ac.th/creditbank/creditbankpdf/manualcreditbank.pdf"
                                target="_blank">คู่มือการใช้งาน</MDBBtn>
                                   <MDBBtn outline  href="https://e-student.kpru.ac.th/creditbank/creditbankpdf/formregistercb.xlsx"
                                target="_blank">ฟอร์มอัพโหลดรายชื่อผู้เรียน</MDBBtn>
                              {/* <MDBCardText>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga
                                aliquid dolorem ea distinctio exercitationem delectus qui, quas
                                eum architecto, amet quasi accusantium, fugit consequatur
                                ducimus obcaecati numquam molestias hic itaque accusantium
                                doloremque laudantium, totam rem aperiam.
                              </MDBCardText> */}
                              {/* https://e-student.kpru.ac.th/creditbank/creditbankpdf/manualcreditbank.pdf */}
                              <hr className="my-4" />
                              <div className="pt-2">
                                  <MDBBtn color="primary" className="waves-effect" onClick={this.register} >
                                      REGISTER <MDBIcon far icon="gem" />
                                  </MDBBtn>
                                  <MDBBtn  outline color="primary" className="waves-effect" onClick={this.login} >
                                    LOGIN <MDBIcon icon="download" />
                                  </MDBBtn>

                              </div>
                      </MDBCol>
                      
                      <MDBCol md="6">
                                      
                      </MDBCol>
                    </MDBRow>

            



            </MDBCardBody>
          </MDBJumbotron>


                    <MDBRow >
                      <MDBCol md="4">
                      </MDBCol>
                        <MDBCol md="4">
                        {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
                          
                        </MDBCol>
                        <MDBCol md="4">
                    </MDBCol>
                    </MDBRow>
                   

                    <CookieConsent
                      location="bottom"
                      buttonText="ยอมรับ"
                      cookieName="creditbank"
                      style={{ background: "#212121" }}

                      buttonStyle={{ color: "#fafafa", fontSize: "18px", background: "#0099CC" }}
                      expires={160}
                    >
                       โดยการใช้เว็บไซต์ของ KPRU คุณรับทราบว่าคุณได้อ่านและทำความเข้าใจ  { }
                   
                      <span style={{ fontSize: "16px" }}>  <a href="https://arit.kpru.ac.th/contents/Disclaimer/Disclaimer.pdf" target="_blank" >นโยบายข้อมูลส่วนบุคคล (PDPA) และข้อกำหนดในการให้บริการ</a> </span>ของเรา
                    </CookieConsent>
                   


                    </MDBContainer>
                    </div>
     
        )
    }
}
